import { useSelector } from 'react-redux';
import { selectors as authSelectors } from 'state/auth';
import { selectors as orderSelectors, selectorsByType } from 'state/order';
import { createContext, useContext, useMemo, useState } from 'react';

const feasibilityContext = createContext(null);
feasibilityContext.displayName = 'feasibilityContext';

const FeasibilityContextProvider = ({ children }) => {
  const data = useFeasibilityProvider();
  return (
    <feasibilityContext.Provider value={data}>
      {children}
    </feasibilityContext.Provider>
  );
};

const useFeasibilityProvider = () => {
  const [isCoreNonCoreEnabled, setIsCoreNonCoreEnabled] = useState(
    useSelector(authSelectors.getIsCoreNonCoreEnabled)
  );
  const orderType = useSelector(orderSelectors.getTypeOfOrder);
  const quote = useSelector(selectorsByType.quote[orderType].getQuote);
  const isQuoteNonCore = !!quote?.feasibility && !quote?.feasibility?.is_core;

  // Get one reason by priority
  const reason = useMemo(() => {
    return quote?.feasibility?.reasons?.reduce((current, r, i) => {
      if (i === 0 || r?.reason_weight < current?.reason_weight) {
        return r;
      }
      return current;
    }, null);
  }, [quote?.feasibility]);

  const feasibilityBypass = !isCoreNonCoreEnabled;

  const getIsOrderNonCore = (order) =>
    !feasibilityBypass &&
    typeof order?.is_core !== 'undefined' &&
    !order.is_core;

  return {
    feasibilityBypass,
    showFeasibilityMessage: !feasibilityBypass && isQuoteNonCore,
    isQuoteNonCore,
    quote,
    orderType,
    reason: reason?.reason_code,
    waitingTime: quote?.feasibility?.waiting_time || 2,
    getIsOrderNonCore,
    setIsCoreNonCoreEnabled,
  };
};

export const useFeasibility = () => {
  return useContext(feasibilityContext);
};

export default FeasibilityContextProvider;
